<section class="portfolio__home">
  <div class="container">
    <div class="row">
      <div class="encabezado">
        <h2 class="encabezado--h2">Proyectos destacados</h2>
        <p class="encabezado--p">
          Principales proyectos desarrollados en los que he implementado las
          principales tegnologias que hacer parte de mi stack
        </p>
      </div>
    </div>
    <div class="row">
      <div class="proyecto">
        <div class="proyecto__text">
          <h3 class="proyecto__text--h3">GSPORT</h3>
          <p class="proyecto__text--p">
            Gsport es una aplicacion para agendar eventos deportivos y
            culturales en donde el usuario podra registrarse e interactuar con
            la plataforma, dentro de esta encontrara eventros divididos por
            categorias, dentro de cada categoria podra visualizar los eventos
            creados por otros usuarios, podra registrarse en el evento, añadirlo
            a favoritos o podra crear su propio evento.
          </p>
          <button class="proyecto__text--btn">Ver mas...</button>
        </div>
        <div class="proyecto__img"></div>
      </div>
    </div>
  </div>
</section>
